var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('i',{class:_vm.isFullscreen?'exit-fullscreen el-icon-close':'el-icon-rank fullscreen',on:{"click":_vm.click}})])
}
var staticRenderFns = []

export { render, staticRenderFns }